import styled from 'styled-components';
import { appConfig } from '../../../../configureApp';
const TrawickPageSectionHeader = styled.div`
  font-size: 14px;
  margin: 5px 0;
  padding: 0;
  font-weight: bold;
  line-height: 1.3em;
  display: flex;
  div.invalid.error & {
    color: #ed1c24;
  }
  .summary-content & {
    font-weight: bold;
  }
`;

const SCTIPageSectionHeader = styled.div`
  font-size: 16px;
  font-family: 'Omnes';
  font-weight: 500; /* Medium */
  color: #4A4A4A;
  margin: 5px 0;
  padding: 0;
  line-height: 1.3em;
  display: flex;

  div.invalid.error & {
    color: #ed1c24;
  }

  .summary-content & {
    font-weight: 500; /* Medium */
  }
`;
const PageSectionHeader = appConfig.reactAppEnv === 'scti' ? SCTIPageSectionHeader : TrawickPageSectionHeader;
export default PageSectionHeader;



// WEBPACK FOOTER //
// ./app/containers/FastCover/components/PageSectionHeader/index.js